import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Eye, Download, Lock, CircleDot } from "lucide-react";
import { api } from "@/lib/api";

const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const HistorySheet = ({ open, onOpenChange, onOpenInventory, onExport, currentId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setLoading(true);
      api.listInventories().then((d) => {
        setItems(d || []);
        setLoading(false);
      });
    }
  }, [open]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        data-testid="history-sheet"
        className="rounded-t-3xl bg-card border-border max-h-[85vh] overflow-y-auto"
      >
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-2xl font-extrabold">Historique</SheetTitle>
          <SheetDescription className="text-muted-foreground">
            Consultez et ré-exportez les inventaires précédents.
          </SheetDescription>
        </SheetHeader>

        <div className="mt-4 space-y-2 pb-4">
          {loading && <div className="text-center text-muted-foreground py-8 text-sm">Chargement…</div>}
          {!loading && items.length === 0 && (
            <div className="text-center text-muted-foreground py-8 text-sm">Aucun inventaire.</div>
          )}
          {items.map((inv) => (
            <div
              key={inv.id}
              data-testid={`history-item-${inv.id}`}
              className={`rounded-2xl border p-3 ${
                inv.id === currentId ? "border-primary/50 bg-primary/5" : "border-border bg-secondary/40"
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold text-sm truncate flex items-center gap-2">
                    {inv.status === "closed" ? (
                      <Lock className="h-3.5 w-3.5 text-rose-400 shrink-0" />
                    ) : (
                      <CircleDot className="h-3.5 w-3.5 text-emerald-400 shrink-0" />
                    )}
                    {inv.name}
                  </div>
                  <div className="text-[11px] text-muted-foreground mt-0.5">
                    {inv.created_by} · {fmtDate(inv.created_at)}
                  </div>
                </div>
                <div className="flex items-center gap-1.5 shrink-0">
                  <Button
                    variant="secondary"
                    size="icon"
                    data-testid={`history-open-${inv.id}`}
                    onClick={() => onOpenInventory(inv.id)}
                    className="h-10 w-10 rounded-xl"
                  >
                    <Eye className="h-4 w-4" />
                  </Button>
                  <Button
                    size="icon"
                    data-testid={`history-export-${inv.id}`}
                    onClick={() => onExport(inv.id, inv.name)}
                    className="h-10 w-10 rounded-xl"
                  >
                    <Download className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
};
